export const morphScratchState: {
  imageData: ImageData | null;
  width: number;
  height: number;
} = {
  imageData: null,
  width: 0,
  height: 0,
};
